const devToolbarItemClass =
  'inline-flex h-8 items-center justify-center rounded-full px-3 text-xs font-semibold leading-none shadow-sm';

export default function DevToolbar() {
  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2">
      <div className={`${devToolbarItemClass} bg-blue-500 text-white`}>
        admin
      </div>
    </div>
  );
}
